import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@honda-canada/design-system-react';
import themeStyles from './CustomizationSummarySectionContent.styles';
const Container = themeStyles.apply(Box, 'Container');
const Cards = themeStyles.apply(Box, 'Cards');
const Cta = themeStyles.apply(Box, 'Cta');
const CustomizationSummarySectionContent = ({ children, editLinkComponent, dataTestId = '', }) => (_jsxs(Container, { "data-testid": `${dataTestId}-section-content`, children: [_jsx(Cards, { "data-testid": `${dataTestId}-section-content-cards`, children: children }), _jsx(Cta, { children: editLinkComponent })] }));
export default CustomizationSummarySectionContent;
